const PAGINATION = {
  PREV_PAGE: 'prev',
  NEXT_PAGE: 'next',
};

export default PAGINATION;
